import React, { memo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LightningFilledIcon from 'transfix-icons/build/LightningFilledIcon'
import { Button } from 'transfix-ui/components/Button'
import { GlobalMessaging } from 'transfix-ui/components/GlobalMessaging'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { Box } from 'transfix-ui/core'
import { INavRoute } from 'types/routes'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { SystemModal } from 'components/SystemModal'
import { generateDefaultRoutes } from 'utils/generateAppDefaults'
import Menu from './components/Menu'
import MobileMenu from './components/MobileMenu'
import 'scss/5_components/_navbar.scss'

interface IHeaderProps {
  routes?: INavRoute[]
  logo?: React.ReactElement
}

const Header = memo<IHeaderProps>(({ logo, routes }) => {
  const history = useHistory()
  const { userDetails, userPermissions: permissions } = useUserDetails()

  const { getFlag } = useFeatureFlagContext()
  const { enabled: isRogersShipmentCreateFormEnabled } = getFlag('enableRogersShipmentCreateForm')
  const { enabled: isMpShippersPageEnabled } = getFlag('mpShipperPage')
  const { enabled: isRogersAuthPagesEnabled } = getFlag('rogersAuthPages')
  const { enabled: isSpotQuoteTool } = getFlag('spotQuoteTool')

  const appRoutes =
    routes ||
    generateDefaultRoutes(
      permissions,
      userDetails?.redirectToFp,
      userDetails?.redirectToTms,
      isRogersShipmentCreateFormEnabled,
      isMpShippersPageEnabled,
      isRogersAuthPagesEnabled,
      isSpotQuoteTool
    )
  const homePage = permissions && permissions.root ? '/booking' : '/dash'

  const isTmsRoute = history.location.pathname.includes('tms')
  const isFPRoute = history.location.pathname.includes('fleet-planner')

  const [openSystemModal, setOpenSystemModal] = useState(false)
  const toggleSystemModalHandler = () => setOpenSystemModal(!openSystemModal)

  return (
    <>
      {!isTmsRoute && !isFPRoute && <GlobalMessaging />}
      <nav>
        <div className='nav-left fl vertically-center'>
          <a href={homePage} className='brand-logo dib' rel='noopener noreferrer' target='_blank'>
            <Box height='100%' display='flex' flexDirection='row' alignItems='center'>
              {logo || <LogoTransfix color='white' width={150} />}
            </Box>
          </a>
          {__ENV__ !== 'production' && (
            <>
              <small className='b ttu dn dib-ns env'> {__ENV__}</small>
              <Button
                variant='text'
                size='large'
                onClick={toggleSystemModalHandler}
                startIcon={<LightningFilledIcon size='large' color='coolGray0' />}>
                Staging API
              </Button>
            </>
          )}
        </div>
        <Menu routes={appRoutes} />
        <MobileMenu routes={appRoutes} />
      </nav>
      {openSystemModal && <SystemModal open={openSystemModal} close={toggleSystemModalHandler} />}
    </>
  )
})

export default Header
